import {
    ArcElement,
    BarController,
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    LineController,
    LineElement,
    PointElement,
    RadialLinearScale,
    TimeScale,
    Title,
    Tooltip
} from 'chart.js'
import annotationPlugin from 'chartjs-plugin-annotation'
import ChartDataLabels from 'chartjs-plugin-datalabels'

ChartJS.register(
    CategoryScale,
    LinearScale,
    RadialLinearScale,
    TimeScale,
    BarElement,
    LineElement,
    PointElement,
    ArcElement,
    LineController,
    BarController,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels,
    annotationPlugin,
    {
        id: 'onRenderComplete',
        afterRender: chart => {
            const event = new CustomEvent('chart-finished', {
                detail: { chartId: chart.id }
            })
            window.dispatchEvent(event)
        }
    }
)

ChartJS.defaults.font.family = 'Montserrat'

export { default as BarChart } from './BarChart'
export { default as DonutChart } from './DonutChart'
export { default as HorizontalBarChart } from './HorizontalBarChart'
export { default as LineChart } from './LineChart'
export { default as PieChart } from './PieChart'
export { default as RadarChart } from './RadarChart'
export { default as SparklineChart } from './SparklineChart'

